import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Link } from 'react-router-dom';

var useStyles = makeStyles((theme) => ({
  root: {
    margin: '0',
    top: '0',
    left: '0',
    zIndex: '3000',
    position: 'fixed',
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: "center",
  }
}));

const LoadCircle = (props) => {
  var classes = useStyles();
  const [progress, setProgress] = React.useState(0);
  var close = false;
  React.useEffect(() => {
    function tick() {
      // reset when reaching 100%
      setProgress((oldProgress) => {
          return oldProgress + 1;
      });
    }

    const timer = setInterval(tick, 50);
    return () => {
        clearInterval(timer);
    };
  }, []);
  classes = useStyles()
  return (
    
    <div className={classes.root}>
      <h4 class="text-light">{'Aguarde...'}</h4>
      <CircularProgress
        variant="determinate"
        style={{
          position: "absolute",
          alignSelf: "center",
          width: "10em",
          height: "10em",
          color: 'black'
        }}
        value={"Load..."}
        color="success"
        value={progress}
      ></CircularProgress>
    </div>
  );
      
};

export default LoadCircle;
